import React, { useEffect, useState } from 'react';
import { getTranslation } from '../../Js/React/Services/legacy';
import { KeyValueEntity } from '../../FrontEndReact/src/Core/Types/base';
interface BizPhraseProps {
	phraseKey: string;
	placeholderValues?: KeyValueEntity[];
}

const BizPhrase = ({ phraseKey, placeholderValues }: BizPhraseProps) => {
	const [phraseValue, setPhraseValue] = useState<string>();
	const [outputValue, setOutputValue] = useState<string>();

	useEffect(() => {
		getTranslation(phraseKey).then((value) => {
			setPhraseValue(value);
		});
	}, [phraseKey]);

	useEffect(() => {
		let value = phraseValue;
		if (phraseValue && placeholderValues) {
			placeholderValues.forEach((pv) => {
				if (pv.Value && value) {
					value = value.replace(pv.Key, pv.Value);
				}
			});
		}
		setOutputValue(value);
	}, [phraseValue, placeholderValues]);

	return <>{outputValue}</>;
};

export default BizPhrase;
